import React, { ReactNode } from 'react';
import { useDispatch } from 'react-redux';

import ConfirmBar from '../../buttons/ConfirmBar';
import closeModalByName from '../../../actions/modal-fn/closeModalByName';
import Modal, { ModalProps } from '../Modal';

export interface ConfirmModalProps<Data = {}> extends ModalProps<Data> {
  chilren?: ModalProps['children'];
  /** Custom text for the cancel button. Default "Cancel". */
  cancelButton?: ReactNode;
  /** Custom text for the confirm button. Default "Confirm". */
  confirmButton?: ReactNode;
  /** Disables the cancel button */
  cancelDisabled?: boolean;
  /** Disables the confirm button */
  confirmDisabled?: boolean;
  /** Callback for confirm button */
  onConfirm?: (data: Data) => void | boolean | Promise<void | boolean>;
  /** Callback for cancel button */
  onCancel?: () => void;
}
const ConfirmModal = <Data extends { content?: ReactNode } = {}>({
  name,
  modalTitle,
  children,
  onCancel,
  onConfirm,
  cancelButton,
  confirmButton,
  cancelDisabled,
  confirmDisabled,
  ...props
}: ConfirmModalProps<Data>) => {
  const dispatch = useDispatch();

  return (
    <Modal<Data>
      name={name}
      modalTitle={modalTitle}
      {...props}
    >
      {({ name: modalName, data, ...args }) => (
        <>
          <Modal.Content>{typeof children === 'function' ? children({ name: modalName, data, ...args }) : children || data?.content}</Modal.Content>
          <Modal.Footer>
            <ConfirmBar
              nopadding
              onCancel={onCancel || (() => dispatch(closeModalByName(modalName)))}
              onConfirm={(async () => {
                if (onConfirm) {
                  const result = await onConfirm(data);
                  if (result === false) return;
                }

                dispatch(closeModalByName(modalName));
              })}
              cancelButton={cancelButton}
              confirmButton={confirmButton}
              cancelDisabled={cancelDisabled}
              confirmDisabled={confirmDisabled}
            />
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default ConfirmModal;
